import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  calcPage: 'precalc',
  showPopUpManager: false,
  isLogin: false,
  userEmail: '',
  userId: '',
  isAdmin: true,
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    setCalcPage: (state, action) => {
      state.calcPage = action.payload
    },
    setShowPopUpManager: (state, action) => {
      state.showPopUpManager = action.payload
    },
    setIsLogin: (state, action) => {
      state.isLogin = action.payload
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload
    },
    setUserId: (state, action) => {
      state.userId = action.payload
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload
    },
  },
});

export const {
  setShowPopUpManager,
  setCalcPage,
  setIsLogin,
  setUserEmail,
  setUserId,
  setIsAdmin

} = homeSlice.actions;


export const selectCalcPage = (state) => state.home.calcPage;
export const selectShowPopUpManager = (state) => state.home.showPopUpManager;
export const selectIsLogin = (state) => state.home.isLogin;
export const selectUserEmail = (state) => state.home.userEmail;
export const selectUserId = (state) => state.home.userId;
export const selectIsAdmin = (state) => state.home.isAdmin;

export default homeSlice.reducer;
